<template>
  <div class='bottomView'>
    <div class="bottom_box">
        <div class="bottom_left">
          <div class="left_top">联系我们</div>
          <div class="left_item">
            <span class="item_text text_1"><span class="item_left">客服热线：</span>{{pageConfig.supportPhone}} ({{pageConfig.supportStaff}})</span>
            <span class="item_text"><span class="item_left">联系地址：</span>{{pageConfig.schoolAddress}}</span>
          </div>
          <div class="left_item">
            <span class="item_text text_1"><span class="item_left">技术支持：</span>{{pageConfig.supportCompany}}</span>
            <span class="item_text"><span class="item_left">本站由：</span>{{pageConfig.supportCompany}}/提供技术支持与运营服务｜粤ICP备18072307号-1</span>
          </div>
        </div>
        <div class="bottom_right">
          <div class="img_wrap" style="margin-right:20px;" v-if="pageConfig.publicAccountQrCode">
            <img :src="$imgUrl+pageConfig.publicAccountQrCode" alt="" @mouseenter="showBigPublichCode = true" @mouseleave="showBigPublichCode = false">
            <img class="img_big" v-show="showBigPublichCode" :src="$imgUrl+pageConfig.publicAccountQrCode" alt="">
            <div class="right_bottom">微信公众号</div>
          </div>
          <div class="img_wrap">
            <img :src="$imgUrl+pageConfig.mobileLearnQrCode" alt="" @mouseenter="showBigCode = true" @mouseleave="showBigCode = false">
            <img class="img_big" v-show="showBigCode" :src="$imgUrl+pageConfig.mobileLearnQrCode" alt="">
            <div class="right_bottom">移动端学习</div>
          </div>

        </div>
      </div>
  </div>
</template>
<script>
export default {
  name:'bottomView',
  data(){
   return{
      showBigPublichCode: false,
      showBigCode: false,
         }
   },
  created(){},
  mounted(){},
  methods: {},
  computed: {},
  props: {
    pageConfig:{
      default(){
        return {}
      }
    }
  },
  watch: {},
  components: {},
}
</script>
<style lang='scss'>
.bottomView{
  height: 168px;
  background-image: linear-gradient(150deg, #409DFF 0%, #3265FF 100%);
  color: #fff;
    padding-top: 40px;
    .bottom_box{
      width: 1380px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .bottom_left{
        .left_top{
          font-family: AlibabaPuHuiTi_2_65_Medium;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 550;
        margin-bottom: 15px;
        }
        .left_item{
          margin-bottom: 8px;
          .item_text{
            font-family: AlibabaPuHuiTi_2_55_Regular;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            font-weight: 400;
            width: 300px;
            word-wrap: break-word;
            word-break: break-all;
            overflow-wrap: break-word;
            .item_left{
              display: inline-block;
              width: 72px;
              text-align: right;
            }
          }
          .text_1{
            display: inline-block;
            margin-right: 60px;
          }
        }
        .item_1{
        }
      }
      .bottom_right{
      display: flex;

    .img_wrap{
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        margin-bottom: 2px;
        position: relative;
        cursor: pointer;
        img{
          width: 90px;
          height: 90px;
        }
        .img_big{
         width: 200px;
          height: 200px;
          position: absolute;
          top: -240px;
          right: -45px;
          -webkit-box-shadow: 0px 0 10px 10px rgba(0, 0, 0, .3);
          box-shadow: 0px 0 10px 10px rgba(0, 0, 0, .3);
          z-index: 999999;
        }
        }
        .right_bottom{
              position: absolute;
              bottom: -20px;
              left: 50%;
              transform: translateX(-50%);
              width: 100px;
          text-align: center;
          font-family: AlibabaPuHuiTi_2_55_Regular;
          font-size: 13px;
          color: #FFFFFF;
          font-weight: 400;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BottomView.vue